import React from 'react'

function BasketStatisticsHeader(props) {
    const { tableType } = props
    return (
        <thead className='BasketStatisticsHeader thead-light'>
            {tableType === 'tableAdd' &&
                <tr>
                    <th>Số giỏ</th>
                    <th>Mã đơn</th>
                    <th>Item</th>
                    <th>Type</th>
                    <th>IP máy</th>
                    <th>Thời gian thêm</th>
                    <th>Người thêm</th>
                </tr>
            }
            {tableType === 'tableDelete' &&
                <tr>
                    <th>Số giỏ</th>
                    <th>Mã đơn</th>
                    <th>IP máy</th>
                    <th>Thời gian xóa</th>
                    <th>Người xóa</th>
                </tr>
            }
        </thead>
    )
}

export default BasketStatisticsHeader